<template>
    <div class="container">
        <div class="main">
            <div class="title" > DIXCEL携手超吉联赛特别涂装赛车登陆上海车展 ，致敬吉利创业35周年 </div>
            <div style="color :gray;font-size :14px;text-align:center;margin-bottom:20px">2021-04-25</div>

            <div style="line-height:30px">
                <div style="text-indent:30px">4月19日第十九届上海车展如期举行。各大品牌百家争鸣，新产品、新战略争相发布，黑科技层出不穷，合力奉上一场“拥抱变化”的业界狂欢</div>
                <div style="text-indent:30px">身披吉利控股集团创业35周年纪念涂装“战袍”的吉利新缤瑞如同万花丛中一抹另类绿意，强势捕捉现场观众的注意力。</div>
                <div style="text-indent:30px">作为2021超吉联赛统一规格赛车，这名赛道悍将以全新面貌为用户讲述了吉利汽车在汽车运动领域一路领航的传奇故事。</div>
                <div style="text-indent:30px">吉利新缤瑞“超吉联赛”统一规格赛车由吉利集团汽车运动部设计并监制
                    ，由铭泰赛车进行赛化改装。该赛车采用DVVT涡轮增压直列四缸发动机。强劲的动力系统为车手们提供了尽情飞驰的基本保障，并对车架、底盘、制动、轮胎、空力、安全等方面进行了赛化改装，全面提升车辆的赛道驾驶性能。整车轻量化、符合FIA/ASN标准的定制赛车防滚架，既能将车重对速度的影响降至最小化，又能为车手安全保驾护航。HANKOOK VENTUS F200专业赛道全热熔轮胎，则是保障速度的利器之一。Öhlins阻尼可调绞牙减震器、赛用轻量化弹簧、定制可调节塔顶能够最大程度减少重量转移对车身的影响。DIXCEL大四活塞卡钳配备DIXCEL355mm刹车盘，DIXCEL RA系列赛用高性能刹车片之后极大提升了车辆的制动性能。</div>
                <div>
                    DIXCEL RA系列900℃高性能定制刹车片极大提升了车辆的制动性能。</div>
                <div style="text-align: center">
                    <el-image  style="width:60%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2021_04_25/1.jpg')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="text-indent:30px">当然最值得介绍的便是这台赛车的35周年特别涂装。全新涂装以星空灰和探索绿为主色，星空灰的科技感十足，蕴涵吉利汽车对高精尖、科技、宇宙、探索的联想，更具有包容性和前瞻性。</div>
                <div style="text-indent:30px">除此之外，这台赛车特别使用“35”作为号码纪念吉利控股集团创业35周年。三十五载砥砺笃行，吉利汽车始终初心不改，在汽车运动领域持续深耕，近年来屡创佳绩。作为吉利汽车主办的单一品牌房车赛事“超吉联赛” 历经10余年发展，已逐步演化成集“体验-培训-竞赛“于一体的专业级赛车入门体验型赛事平台。2021赛季超吉联赛在经过赛制、赛车升级后更是以全新面貌。再次带领赛车爱好者开启逐梦之旅</div>
                <div style="text-align: center">
                    <el-image  style="width:60%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2021_04_25/2.jpg')"
                               fit="fit">
                    </el-image>
                    <el-image  style="width:60%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2021_04_25/3.jpg')"
                               fit="fit">
                    </el-image>
                    <el-image  style="width:60%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2021_04_25/4.jpg')"
                               fit="fit">
                    </el-image>
                    <el-image  style="width:60%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2021_04_25/5.jpg')"
                               fit="fit">
                    </el-image>
                    <el-image  style="width:60%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2021_04_25/6.jpg')"
                               fit="fit">
                    </el-image> <el-image  style="width:60%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2021_04_25/7.jpg')"
                               fit="fit">
                    </el-image>
                    <el-image  style="width:60%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2021_04_25/8.jpg')"
                               fit="fit">
                    </el-image>
                    <el-image  style="width:60%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2021_04_25/9.jpg')"
                               fit="fit">
                    </el-image>
                </div>

            </div>




        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return{

            }
        }
    }
</script>

<style lang="stylus" scoped>


    .container
        background-color : #000
        .box_one
            width: 100%;

        .box_bottom
            width: 100%;
            background-color #000


    .main {
        margin-bottom: 5px;
        width: 1003px;
        background-color: #fff;
        margin: 0 auto;
        position: relative;
        box-sizing: border-box;
        padding: 62px 50px 52px;
    }
    .title {
        color :#ab191d;
        text-align:center;
        margin-bottom 10px
    }


</style>
